import { render, staticRenderFns } from "./ChatChannelTabs.vue?vue&type=template&id=00454aee&scoped=true&lang=pug&"
import script from "./ChatChannelTabs.vue?vue&type=script&lang=js&"
export * from "./ChatChannelTabs.vue?vue&type=script&lang=js&"
import style0 from "./ChatChannelTabs.vue?vue&type=style&index=0&id=00454aee&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00454aee",
  null
  
)

component.options.__file = "ChatChannelTabs.vue"
export default component.exports